module.exports = __webpack_public_path__ + "media/my_images/owner/step1-46366de635193c621d0421f0592c1cee.svg";